import {defineAsyncComponent} from "vue";
import {useLoader} from "@/js/Plugins/Loader.js";
import {useModal} from "@/js/Plugins/Modal.js";
import Logout from "@/js/Components/Logout.vue";
import Language from "@/js/Views/Language/Index.vue";

export function useRoutes() {
    return [

    ];
}

export function useGlobalRoutes()
{
    return [
        {
            path: '/language',
            name: 'language',
            meta: {
                auth: true,
                confirm: true,
            },
            beforeEnter(to, from, next) {
                const modal = useModal();
                modal.open(Language)
                return next(false);
            }
        },
        {
            path: 'logout',
            name: 'logout',
            meta: {
                auth: true,
                confirm: true,
            },
            beforeEnter(to, from, next) {
                const modal = useModal();
                modal.open(Logout)
                return next(false);
            }
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'error',
            component: defineAsyncComponent(() => import('@/js/Views/Error.vue'))
        }
    ];
}